import BooleanField from '../../../../components/BooleanField'
import EditableField from '../../../../components/EditableFields'
import React, { useState, useEffect } from 'react';
import DescripcionActividadSolicitud from '../components/infoSolicitudes'
import WompiPagoWidget from '../../Contabilidad/Modulos/WompiPago'
import { 
  ShieldCheck, 
  CheckCircle2,
  DollarSign, 
  CreditCard, 
  Info,
  AlertTriangle,
  RefreshCw,
  Loader2,
  Clock,
  Ban,
} from 'lucide-react';
import ContainerPagos from '../../Contabilidad/Modulos/ContainerPagos'

const ClienteView = ({
  solicitud,
  isCliente,
  tipoServiciosListAdmin,
  handleSave,
  materiasOptions,
}) => {
  
  return (
    <div className="space-y-4">

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          <EditableField
            field="Servicio"
            label="Tipo de Servicio"
            value={solicitud.Servicio}
            type="react-select"
            options={tipoServiciosListAdmin}
            onSave={handleSave}
          />

          <EditableField
            field="materia"
            label="Materia"
            value={solicitud.materia}
            type="react-select"
            options={materiasOptions}
            isAdmin={isCliente}
            onSave={handleSave}
            placeholder="Ingrese la materia"
          />

          <EditableField
            field="fechaentrega"
            label="Fecha de entrega"
            value={solicitud.fechaentrega}
            type="datetime"
            isAdmin={isCliente}
            onSave={handleSave}
            placeholder="Ingrese la fecha"
          /> 
          
          <EditableField
            label="Fecha de sistema"
            value={solicitud.fechasistema}
            type="datetime"
            isAdmin={false}
            onSave={handleSave}
          />  


          {/* PODER VER INFO DE UNAD COMPLETO */}
          
        </div>
        
      
        <div className="bg-white p-4 rounded-lg border">
          
          <DescripcionActividadSolicitud 
            key={solicitud.ultimaModificacion} 
            solicitud={solicitud}
            isAdmin = {false}
            onUpdateSolicitud = {handleSave}
            />
          
          <p className="text-sm text-gray-600 mt-2">{solicitud.formato}</p>
        </div>

        {/* EXPIRADO */}
        {solicitud.Estado === 'EXPIRADO' && (
          <div className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-8 text-center shadow-sm">
            <div className="flex justify-center mb-4">
              <div className="bg-amber-100 p-4 rounded-full">
                <AlertTriangle size={40} className="text-amber-600" />
              </div>
            </div>
            <h3 className="text-xl font-black text-amber-900 mb-2 uppercase">Solicitud Expirada</h3>
            <p className="text-gray-700 mb-6 max-w-md mx-auto">
              El tiempo límite para el pago ha vencido. Si aún deseas realizar esta actividad, 
              debemos volver a confirmar la disponibilidad del tutor.
            </p>
            <button
              onClick={() => handleSave('Estado', 'DISPONIBLE')}
              className="inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-8 rounded-xl transition-all transform hover:scale-105 shadow-md"
            >
              <RefreshCw size={20} />
              Solicitar nueva disponibilidad
            </button>
          </div>
        )}

        {/* NO PODEMOS */}
        {solicitud.Estado === 'NO PODEMOS' && (
          <div className="bg-gray-50 border-2 border-gray-200 rounded-2xl p-8 text-center shadow-sm">
            <div className="flex justify-center mb-4">
              <div className="bg-gray-200 p-4 rounded-full text-gray-500">
                <Ban size={40} />
              </div>
            </div>
            <h3 className="text-xl font-black text-gray-800 mb-2 uppercase">No podemos ayudarte</h3>
            <p className="text-gray-600 max-w-md mx-auto">
              Tras revisar los requerimientos técnicos y la disponibilidad, lamentamos informarte 
              que no podemos tomar esta actividad en este momento.
            </p>
          </div>
        )}


        {/* SECCIÓN DE COTIZACIÓN EN PROCESO */}
        {(solicitud.precioCobradoCliente === 0 ) && 
          !['EXPIRADO', 'NO PODEMOS'].includes(solicitud.Estado) && (
          <div className="bg-blue-50 border-2 border-blue-200 rounded-2xl p-10 text-center shadow-sm animate-pulse">
            <div className="flex justify-center mb-6">
              <div className="bg-blue-100 p-5 rounded-full relative">
                <Clock size={48} className="text-blue-600" />
                <Loader2 
                  size={24} 
                  className="text-blue-400 absolute top-0 right-0 animate-spin" 
                />
              </div>
            </div>
            
            <h3 className="text-2xl font-black text-blue-900 mb-3 uppercase tracking-tight">
              Estamos cotizando tu servicio
            </h3>
            
            <div className="max-w-md mx-auto space-y-4">
              <p className="text-blue-800 text-lg font-medium">
                ¡Ya recibimos tus requerimientos! Nuestro equipo académico está revisando la complejidad y disponibilidad de los tutores.
              </p>
              
              <div className="flex items-center justify-center gap-2 text-blue-600 bg-white/50 py-2 px-4 rounded-full border border-blue-100 inline-block mx-auto">
                <span className="relative flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500"></span>
                </span>
                <span className="text-sm font-bold uppercase tracking-widest">
                  En un momento te daremos razón
                </span>
              </div>
              
              <p className="text-gray-500 text-sm italic">
                Te notificaremos por correo y/o WhatsApp una vez el precio esté listo.
              </p>
            </div>
          </div>
        )}

        {/* SECCIÓN DE PAGOS*/}
        {(solicitud.precioCobradoCliente != 0) &&['DISPONIBLE', 'ESPERANDO', 'A PAGAR'].includes(solicitud.Estado) && (
          <div className="space-y-4">


            Este mensaje va a varia dependiendo de : 

            TESIS
            TALLERES
            EXAMENES / QUICES

            {/* CARD DE PRECIO Y BENEFICIOS */}
            <div className="bg-gradient-to-br from-emerald-50 via-white to-teal-50 border border-emerald-200 rounded-2xl p-6 shadow-md">
                  
                  {/* Encabezado de Precio */}
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6 border-b border-emerald-100 pb-6">
                    <div className="flex items-center gap-4">
                      <div className="bg-emerald-600 p-3 rounded-xl text-white shadow-lg">
                        <DollarSign size={32} />
                      </div>
                      <div>
                        <p className="text-sm font-bold text-emerald-700 uppercase tracking-widest">
                          El coste de tu servicio es:
                        </p>
                        <span className="text-4xl font-black text-emerald-900">
                          $ {Number(solicitud.precioCobradoCliente).toLocaleString()}
                        </span>
                      </div>
                    </div>
                    
                    <div className="bg-emerald-100 text-emerald-700 px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2">
                      <ShieldCheck size={18} />
                      Pago 100% Seguro
                    </div>
                  </div>

                  {/* SECCIÓN DE BENEFICIOS */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div className="space-y-3">
                      <h4 className="font-bold text-emerald-800 flex items-center gap-2">
                        <CheckCircle2 size={18} /> Tu servicio incluye:
                      </h4>
                      <ul className="text-sm text-gray-600 space-y-2 ml-1">
                        <li className="flex items-center gap-2">
                          <span className="text-emerald-500">✅</span> Trabajo 100% original + certificado Turnitin
                        </li>
                        <li className="flex items-center gap-2">
                          <span className="text-emerald-500">✅</span> Soporte completo hasta después de la entrega
                        </li>
                      </ul>
                    </div>

                    <div className="space-y-3">
                      <h4 className="font-bold text-emerald-800 flex items-center gap-2">
                        <Info size={18} /> Proceso de trabajo:
                      </h4>
                      <div className="text-xs bg-white/50 border border-emerald-100 p-3 rounded-xl text-gray-700 leading-relaxed">
                        <span className="font-bold text-emerald-700">Pagas 50%</span> → 
                        Cuando esté listo te lo mostramos → 
                        <span className="font-bold text-emerald-700">Pagas el resto</span> → 
                        Te entregamos el archivo final.
                      </div>
                    </div>
                  </div>

                  {/* MENSAJE DE SEGURIDAD WOMPI */}
                  <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 text-sm text-blue-800 flex gap-3 items-start">
                    <CreditCard className="text-blue-600 shrink-0" size={20} />
                    <p>
                      <span className="font-bold">Facilidades de Pago:</span> Puedes pagar de forma segura con tarjeta de crédito, débito o PSE a través de <span className="font-black">Wompi</span>.
                      Tambien puedes pagar por transferencia directa adjuntado el pago en el boton transferencia directa
                    </p>
                  </div>
            </div>

            <ContainerPagos
              precioACobrar={solicitud.precioCobradoCliente}
              categoria={"SOLICITUD"}
              idReferencia={solicitud.idcotizacion}
              sumaPagosClientes={solicitud.getSumaPagosClientes()}
              nombreEmpresa={solicitud.nombreEmpresa}
              identificador={solicitud.idcotizacion}
            />

          </div>
        )}
        

      </div>
  )
}

export default ClienteView